// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"12d45a4b","663":"a71d9606"}[chunkId] + ".chunk.js";
};